import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './index.less';
import 'antd/dist/antd.min.css';

import Store from './redux/index';
import { unregister } from './registerServiceWorker';
// eslint-disable-next-line
window.__ULEARNING_SCHOOL_WEB_ENV__ = WEB_ENV;
let App = null;
import('./App').then(module => {
	App = module.default;
	ReactDOM.render(
		<Provider store={Store}>
			<App />
		</Provider>,
		document.getElementById('root')
	);
});
unregister();


// WEBPACK FOOTER //
// ./src/index.js